/* istanbul ignore file */
/* tslint:disable */

import type { ApiRequestOptions } from './ApiRequestOptions'

type Resolver<T> = (options: ApiRequestOptions) => Promise<T>
type Headers = Record<string, string>

export type OpenAPIConfig = {
  BASE: string
  VERSION: string
  WITH_CREDENTIALS: boolean
  CREDENTIALS: 'include' | 'omit' | 'same-origin'
  TOKEN?: string | Resolver<string>
  USERNAME?: string | Resolver<string>
  PASSWORD?: string | Resolver<string>
  HEADERS?: Headers | Resolver<Headers>
  ENCODE_PATH?: (path: string) => string
}

export const OpenAPI: OpenAPIConfig = {
  BASE: window.location.protocol + '//' + window.location.host,
  VERSION: '1.0.0 (v1)',
  WITH_CREDENTIALS: false,
  CREDENTIALS: 'include',
  TOKEN: localStorage.getItem('access_token') || undefined,
  USERNAME: undefined,
  PASSWORD: undefined,
  HEADERS: undefined,
  ENCODE_PATH: undefined,
}

if (process.env.NODE_ENV === 'development') {
  OpenAPI.BASE = 'http://localhost:8000'
}

if (process.env.REACT_APP_TEST_PROD_MODE == 'true') {
  OpenAPI.BASE = 'http://studio-backend.console.svc.cluster.local:80'
}
